<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="12" class="mt-2 ml-2 mb-2">
							<v-btn @click="shopStop.show=true" small color="info" dense>停课设置</v-btn>
						</v-col>
					</v-row>
					
					<v-divider></v-divider>
				</template>
				

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="10" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		<!-- 停课设置 -->
		<setShopStopDate :show="shopStop.show" @cancel="shopStop.show=false" @success="setShopStopSuccess"></setShopStopDate>
	</v-card>
</template>

<script>

	import utils from "../../../config/utils.js"
	import setShopStopDate from "../../../components/set_shop_stop_date.vue"
	export default {
		name: "shop-stop-list",
		components:{setShopStopDate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [
					{text: '首页',disabled: false,href: "/"},
					{text: '系统管理',disabled: true},
					{text: '停课管理',disabled: true},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{text: '开始日期',value: 'dateFrom',sortable: false},
						{text: '结束日期',value: 'dateTo',sortable: false},
						{text: '停课原因',value: 'stopReason',sortable: false},
						{text: '顺延课次数',value: 'dealRecordCount',sortable: false},
						{text: '创建时间',value: 'createAt',sortable: false},
						{text: '创建人',value: 'creatorName',sortable: false},
					],
					list: [],
				},
				query: {
					loading:false,
					page: 1,
					size: 20,
				},
				shopStop:{
					show:false
				}
				
				
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getDataTableList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataTableList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getDataTableList();
			},
			setShopStopSuccess(){
				this.shopStop.show= false;
				this.getDataTableList();
			},
			getDataTableList() {
				const that = this;
				this.query.loading = true;
				let url = `/sys/shop/${this.shopId}/stop/date/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						
						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			

		}
	}
</script>

<style>
</style>
